export default __webpack_public_path__ + "static/media/V_Vassoura.3014e92f.mp3";